import { Home, Wand2, Heart, Globe2, UsersRound, Settings } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface NavItem {
  to: string;
  icon: LucideIcon;
  label: string;
}

export interface NavSection {
  label?: string;
  items: NavItem[];
}

export const navSections: NavSection[] = [
  { items: [{ to: "/dashboard/home", icon: Home, label: "Home" }] },
  {
    items: [
      { to: "/dashboard/studio", icon: Wand2, label: "Studio" },
      { to: "/dashboard/persona", icon: Heart, label: "Persona" },
    ],
  },
  {
    items: [
      { to: "/dashboard/publish", icon: Globe2, label: "Publish & share" },
    ],
  },
  {
    items: [
      { to: "/dashboard/visitors", icon: UsersRound, label: "Visitors" },
      { to: "/dashboard/settings", icon: Settings, label: "Settings" },
    ],
  },
];

export const navItems: NavItem[] = navSections.flatMap((section) => section.items);
